import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=1bdd4bbe&scoped=true"
import script from "./UploadList.vue?vue&type=script&lang=js"
export * from "./UploadList.vue?vue&type=script&lang=js"
import style0 from "./UploadList.vue?vue&type=style&index=0&id=1bdd4bbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd4bbe",
  null
  
)

export default component.exports